/*
 * Homepage sale banner: one-time reveal + percentage count-up when the banner enters view.
 * Loaded only for the image-banner section ending in "__image_banner_wrzakT".
 */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    document.querySelectorAll('[id$="__image_banner_wrzakT"]').forEach((section) => {
      if (section.dataset.saleBanner) return;
      section.dataset.saleBanner = 'on';

      const heading = section.querySelector('.banner__heading');
      const count = wrapPercentage(heading);

      if (reduceMotion || !('IntersectionObserver' in window)) return;

      section.classList.add('sb-armed');
      if (count) count.el.textContent = '0';

      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        requestAnimationFrame(() => section.classList.add('sb-inview'));
        if (count) countUp(count.el, count.value, 1000);
      }, { threshold: 0.35 });
      observer.observe(section);
    });
  }

  /* Wrap the first "NN%" in the heading so only the digits animate; screen readers get the final text */
  function wrapPercentage(heading) {
    if (!heading) return null;
    const existing = heading.querySelector('.sb-count');
    if (existing) return { el: existing, value: Number(existing.dataset.target) };
    // Label from the untouched text, before any digit is animated
    if (!heading.hasAttribute('aria-label')) {
      heading.setAttribute('aria-label', heading.textContent.replace(/\s+/g, ' ').trim());
    }
    const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      const match = /(\d+)%/.exec(node.textContent);
      if (!match) continue;
      const before = node.textContent.slice(0, match.index);
      const after = node.textContent.slice(match.index + match[1].length);
      const span = document.createElement('span');
      span.className = 'sb-count';
      span.setAttribute('aria-hidden', 'true');
      span.dataset.target = match[1];
      span.textContent = match[1];
      node.replaceWith(document.createTextNode(before), span, document.createTextNode(after));
      return { el: span, value: Number(match[1]) };
    }
    return null;
  }

  function countUp(el, target, duration) {
    const start = performance.now();
    const easeOut = (t) => 1 - Math.pow(1 - t, 4);
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      el.textContent = String(Math.round(target * easeOut(t)));
      if (t < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
